import React, { useState, useEffect, useCallback, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import ChoiceMappingsTable from "@/components/choice-mappings/choice-mappings-table";
import ChoiceMappingForm from "@/components/choice-mappings/choice-mapping-form";
import { PageWrapper } from "@/components/layout/PageWrapper";

interface ChoiceMappingsPageProps {
  onRefreshReady?: (refreshFn: () => void, isRefreshing: boolean) => void;
}

const ChoiceMappingsPage = ({ onRefreshReady }: ChoiceMappingsPageProps = {}) => {
  const [showAddMappingModal, setShowAddMappingModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();
  const onRefreshReadyRef = useRef(onRefreshReady);
  onRefreshReadyRef.current = onRefreshReady;

  // DEBUG: Render counter
  const renderCount = useRef(0);
  renderCount.current++;
  console.log(`[ChoiceMappingsContent] Render #${renderCount.current}, isRefreshing=${isRefreshing}, hasOnRefreshReady=${!!onRefreshReady}`);

  const handleRefresh = useCallback(async () => {
    console.log(`[ChoiceMappingsContent] handleRefresh called`);
    setIsRefreshing(true);
    await queryClient.invalidateQueries({ queryKey: ["/api/choice-mappings"] });
    await queryClient.invalidateQueries({ queryKey: ["/api/field-mappings"] });
    setTimeout(() => setIsRefreshing(false), 500);
  }, [queryClient]);

  // Expose refresh function to parent - only run once on mount and when isRefreshing changes
  useEffect(() => {
    console.log(`[ChoiceMappingsContent] useEffect running, calling onRefreshReadyRef`);
    onRefreshReadyRef.current?.(handleRefresh, isRefreshing);
  }, [handleRefresh, isRefreshing]);

  return (
    <PageWrapper padding="small">
      <ChoiceMappingsTable onAddMapping={() => setShowAddMappingModal(true)} />

      {showAddMappingModal && (
        <ChoiceMappingForm
          isOpen={showAddMappingModal}
          onClose={() => setShowAddMappingModal(false)}
          onSuccess={() => setShowAddMappingModal(false)}
        />
      )}
    </PageWrapper>
  );
};

export default ChoiceMappingsPage;
